module.exports = __webpack_public_path__ + "img/splicing_prograss_four_sss.7dc1744a.png";